module.exports = "/deep/.mat-option-text {\n  display: inline-block;\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center !important; }\n\n/deep/th.mat-header-cell {\n  text-align: center !important;\n  padding: 0;\n  border-bottom-width: 1px;\n  border-bottom-style: solid; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/admin-layout/admin-layout.component.scss
// module id = ./src/app/layouts/admin-layout/admin-layout.component.scss
// module chunks = main